import { render, staticRenderFns } from "./NewTranslation.vue?vue&type=template&id=208c0614&"
import script from "./NewTranslation.vue?vue&type=script&lang=ts&"
export * from "./NewTranslation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports